/**
 * Pairs map empty `*Reactivation*` CMS fields onto the non-reactivation field the
 * subscription-offer page-config already reads (`_browser` and `_browser-2-0-rebrand`).
 * @type {readonly (readonly [string, string])[]}
 */
const REACTIVATION_FIELD_PAIRS = [
	['primaryReactivationProduct', 'primarySubscriptionProduct'],
	['primaryReactivationProductOfferDisclaimerText', 'primaryProductOfferDisclaimerText'],
	['primaryReactivationProductApplePayProductLabel', 'primaryProductApplePayProductLabel'],
	['primaryReactivationProductApplePayTrialLabel', 'primaryProductApplePayTrialLabel'],
	['primaryReactivationProductPaymentInterval', 'primaryProductPaymentInterval'],
	['primaryReactivationProductPaymentIntervalCount', 'primaryProductPaymentIntervalCount'],
	['primaryReactivationProductPriceValue', 'primaryProductPriceValue'],
	['primaryReactivationProductTrialLengthInDays', 'primaryProductTrialLengthInDays'],
	['alternateReactivationProduct', 'alternateSubscriptionProduct'],
	['alternateReactivationProductOfferDisclaimerText', 'alternateProductOfferDisclaimerText'],
	['alternateReactivationProductApplePayProductLabel', 'alternateProductApplePayProductLabel'],
	['alternateReactivationProductApplePayTrialLabel', 'alternateProductApplePayTrialLabel'],
	['alternateReactivationProductPaymentInterval', 'alternateProductPaymentInterval'],
	['alternateReactivationProductPaymentIntervalCount', 'alternateProductPaymentIntervalCount'],
	['alternateReactivationProductPriceValue', 'alternateProductPriceValue'],
	['alternateReactivationProductTrialLengthInDays', 'alternateProductTrialLengthInDays'],
];

/**
 * @param {unknown} arg_value - CMS/API flag (`custom_fields.reactivationsAllowed`).
 * @returns {boolean}
 */
function isTruthyReactivationsAllowed(arg_value) {
	return (
		arg_value === true || (typeof arg_value === 'string' && arg_value.toLowerCase() === 'true')
	);
}

/**
 * @param {unknown} arg_value - Field value before hydration.
 * @returns {boolean}
 */
function isEmpty(arg_value) {
	return arg_value === undefined || arg_value === null || arg_value === '';
}

/**
 * When reactivations are allowed, fills empty Reactivation-variant template fields from
 * the corresponding non-reactivation fields so inactive authenticated users receive
 * offer disclaimer/copy (e.g. terms checkbox legal text).
 * @param {Record<string, unknown>} arg_custom_fields - `custom_fields` from SpecialOffer/Get.
 * @returns {Record<string, unknown>}
 */
export function hydrateReactivationFields(arg_custom_fields) {
	if (!arg_custom_fields || !isTruthyReactivationsAllowed(arg_custom_fields.reactivationsAllowed)) {
		return arg_custom_fields;
	}

	const hydrated = { ...arg_custom_fields };
	for (const [reactivationKey, fallbackKey] of REACTIVATION_FIELD_PAIRS) {
		if (isEmpty(hydrated[reactivationKey]) && !isEmpty(hydrated[fallbackKey])) {
			hydrated[reactivationKey] = hydrated[fallbackKey];
		}
	}
	return hydrated;
}
